var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuIconAlarmNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3355 5.60658C18.1827 5.57625 18.0273 5.54904 17.8692 5.52498C17.647 4.70132 16.8947 4.09521 16.0008 4.09521C15.1083 4.09521 14.357 4.69943 14.1335 5.52113C11.8702 5.85639 10.143 6.82546 8.94549 8.32639C7.48043 10.1626 6.97073 12.5952 6.97073 15.0649V20.3356L4.98877 22.3176C4.09485 23.2115 4.72797 24.74 5.99216 24.74H26.0093C27.2735 24.74 27.9066 23.2115 27.0127 22.3176L25.0307 20.3356V15.0649C25.0307 14.3149 24.9812 13.5634 24.869 12.8284C24.4316 12.9404 23.9733 12.9999 23.501 12.9999C23.0733 12.9999 22.657 12.9511 22.2573 12.8587C22.3872 13.5397 22.4507 14.2788 22.4507 15.0649V21.4043L23.2064 22.16H8.79506L9.55073 21.4043V15.0649C9.55073 12.8907 10.0085 11.1308 10.9622 9.93549C11.8731 8.79381 13.3957 7.96994 16.0007 7.96994C16.7716 7.96994 17.4483 8.0449 18.0427 8.18083C18.0152 7.95773 18.001 7.73049 18.001 7.49994C18.001 6.83462 18.1191 6.19689 18.3355 5.60658ZM19.8708 26.0347C19.8708 28.172 18.1381 29.9047 16.0008 29.9047C13.8635 29.9047 12.1308 28.172 12.1308 26.0347H19.8708Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 7.5,
    r: 3.5,
    fill: "#E7290F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconAlarmNew);
export default __webpack_public_path__ + "static/media/menu_icon_alarm_new.8309044f0b1a1f302a12fe19ea064a71.svg";
export { ForwardRef as ReactComponent };